// Angular
import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

// Services
import { CoreService } from '../../../shared/services';

// Libraries
import { Observable } from 'rxjs';

// Models
import { AppCleanup } from '../../../shared/models';
import { LegacyUnitConfigViewModel, UnitConfigChannelDto, UnitConfigViewModel } from '../models/unit-config-view.model';

@Injectable({
	providedIn: 'root',
})
export class UnitConfigService extends AppCleanup {
	private readonly unitConfigUrl: string;
	domain: string = window.location.hostname;

	constructor(
		private http: HttpClient,
		private coreService: CoreService
	) {
		super();
		this.unitConfigUrl = `${this.apiUrl}api/unitconfig`;
	}

	getUnitConfigs() {
		return this.http.get<UnitConfigViewModel[]>(this.unitConfigUrl);
	}

	getUnitConfig(unitConfigId: number) {
		return this.http.get<UnitConfigViewModel>(`${this.unitConfigUrl}/${unitConfigId}`);
	}

	createUnitConfig(unitConfig: UnitConfigViewModel) {
		return this.http.post<UnitConfigViewModel>(`${this.unitConfigUrl}`, unitConfig);
	}

	updateUnitConfig(unitConfig: UnitConfigViewModel) {
		return this.http.put<UnitConfigViewModel>(`${this.unitConfigUrl}/${unitConfig.id}`, unitConfig);
	}

	// TODO new...
	UpdateUnitConfigurationOffsetAndGain(dto: UnitConfigChannelDto) {
		return this.http.put<UnitConfigChannelDto>(`${this.unitConfigUrl}/updateOffsetAndGain`, dto);
	}

	deleteUnitConfig(unitConfigId: number) {
		return this.http.delete<UnitConfigViewModel>(`${this.unitConfigUrl}/${unitConfigId}`);
	}

	importUnitConfig(legacyUnitConfigs: LegacyUnitConfigViewModel[]) {
		return this.http.post<LegacyUnitConfigViewModel[]>(`${this.unitConfigUrl}/legacy`, legacyUnitConfigs);
	}

	getUnitConfigTemplates() {
		return this.http.get<any>(`${this.unitConfigUrl}/templates`);
	}

	validateExpression(valdationObject: ValidationObject): Observable<ValidationResponse> {
		return this.http.post<ValidationResponse>(`https://${this.domain}:5003/api/unitconfigurations/validate`, valdationObject);
	}
}

export class ValidationObject {
	expression: string;
	channelNames: string[];
}

export class ValidationResponse {
	isValid: boolean;
	errorMessage: string;
}
